import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=2bbd8995&"
import script from "./Disclosure.vue?vue&type=script&lang=ts&"
export * from "./Disclosure.vue?vue&type=script&lang=ts&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_dc55b0b5/src/components/button/Circle.vue').default,Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default,AnimateExpand: require('/tmp/build_dc55b0b5/src/components/animate/AnimateExpand.vue').default})
